import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "../axios/axios";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useLocation } from "react-router";
import { formatDate } from "../helper/formatDate";
import ActionButton from "../components/ActionButton";
import { Link } from "react-router-dom";
import { iconContainer, pageTitle, showIconsContainer, termsTitle, whiteCard } from "../common/cssclasses";





export default function SingleTermsAndConditionsShowPage() {
  const { currentLanguage } = useSelector((state) => state.studBookSlice);
  const [show, setShow] = useState(null);
  const { translate } = useTranslate();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const id = searchParams.has("id") ? searchParams.get("id") : "";
  const lang = localStorage.getItem("eahsLang") ?? "en";

  function getCurrentLanguageUmbraco() {
    // Replace this with your logic to retrieve the current language
    // For example, you can retrieve it from localStorage or from a state variable
    const lang = localStorage.getItem("eahsLang") ?? "en";
    if (lang == "en") return "en-US";
    else return "ar-AE"; // Defaulting to English for demonstration
  }

  useEffect(() => {
    async function getdata() {
      const response = await axios.get(
        `/Shows/GetShowbyId?id=${id}&langauge=${lang}&language=1`,
        {
          headers: {
            "accept-language": getCurrentLanguageUmbraco(),
          },
        }
      );

      setShow(response.data.result);
    }
    getdata();
  }, [currentLanguage]);

  return (
    <>
      {!show && <Loader />}
      {!!show && (
        <>
          <>

            <div className="row rtl" >
              <h2 className={termsTitle}>
                {!!show?.logo &&
                  <img src={show.logo} alt={show.showName} className="me-3" onError={(e) => e.currentTarget.classList.add('d-none')} style={{ maxHeight: 60 }} />
                }
                {show.showName}
              </h2>

              <div className={showIconsContainer} >

                {!!show?.startDate && (
                  <div className={iconContainer}>
                    <i
                      className="fa fa-calendar C89C66"
                    ></i>
                    <span>{formatDate(show.startDate)}</span>
                  </div>
                )}
                {!!show?.endDate && (
                  <div className={iconContainer}>
                    <i
                      className="fa fa-calendar C89C66"
                    ></i>
                    <span>{formatDate(show.endDate)}</span>
                  </div>
                )}
                {!!show?.cityName && (
                  !!show?.mapLocationSharedUrl ?
                    <Link to={show?.mapLocationSharedUrl} target="_blank" className={iconContainer}>
                      <i
                        className="fa-solid fa-location-dot C89C66"
                      ></i>
                      <span className="C89C66">
                        {show.cityName}
                      </span>
                    </Link> :
                    <div className="col-md-3  ">
                      <i
                        className="fa-solid fa-location-dot C89C66"
                      ></i>
                      <span>
                        {show.cityName}
                      </span>
                    </div>
                )}
                {!!show?.showRank &&
                  <div className={iconContainer}>
                    <i className=" fa fa-trophy C89C66"></i>
                    <span>{show.showRank}</span>
                  </div>
                }
              </div>
            </div>

            <>
              <div className="row">
                <h5 className="col-lg-12 col-md-12 col-sm-12 fw-bold rtl">
                  {translate(
                    "web.T&C",
                    "Terms and Conditions"
                  )}
                </h5>
                <div className="col-12">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: show.termsAndConditionsEn,
                    }}
                    className={whiteCard}
                  />
                </div>
              </div>
            </>


          </>

        </>
      )}
    </>
  );
}
